import type * as React from "react";
import { useFormContext } from "react-hook-form";
import type { ZodEmail, ZodString } from "zod";

interface FormTextFieldProps {
	formKey: string;
	schema: ZodString | ZodEmail;
}

const FormTextField: React.FC<FormTextFieldProps> = ({ formKey, schema }) => {
	const { register } = useFormContext();

	return (
		<input
			type="text"
			id={formKey}
			placeholder={schema.description || ""}
			{...register(formKey)}
		/>
	);
};

export default FormTextField;
